module.exports = __webpack_public_path__ + "img/DW365-179.e856d281.jpg";